import { render, staticRenderFns } from "./RelatorioPedidoTotaisChart.vue?vue&type=template&id=762e06d8"
import script from "./RelatorioPedidoTotaisChart.vue?vue&type=script&lang=js"
export * from "./RelatorioPedidoTotaisChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports